import { createSelector } from 'reselect';

const selectAccountLedgers = (state: any) => state.accountLedgers;


export const selectAccountLedgersCurrentItem = createSelector([selectAccountLedgers], (accountLedgers) => accountLedgers.current);

export const selectAccountLedgersListItems = createSelector([selectAccountLedgers], (accountLedgers) => accountLedgers.list);

export const selectAccountLedgersItemById = (itemId: any) =>
    createSelector(selectAccountLedgersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAccountLedgersQueryItems = createSelector([selectAccountLedgers], (accountLedgers) => accountLedgers.query);

export const selectAccountLedgersCreatedItem = createSelector([selectAccountLedgers], (accountLedgers) => accountLedgers.create);

export const selectAccountLedgersUpdatedItem = createSelector([selectAccountLedgers], (accountLedgers) => accountLedgers.update);

export const selectAccountLedgersReadItem = createSelector([selectAccountLedgers], (accountLedgers) => accountLedgers.read);

export const selectAccountLedgersDeletedItem = createSelector([selectAccountLedgers], (accountLedgers) => accountLedgers.delete);

export const selectAccountLedgersSearchedItems = createSelector([selectAccountLedgers], (accountLedgers) => accountLedgers.search);

export const selectAccountLedgersItemsCount = createSelector([selectAccountLedgers], (accountLedgers) => accountLedgers.count);

export const selectAccountLedgersItemsFilter = createSelector([selectAccountLedgers], (accountLedgers) => accountLedgers.filter);